// extracted by mini-css-extract-plugin
export var checkContainer = "mapLegend-module--checkContainer--c52bc";
export var checkboxWrapper = "mapLegend-module--checkboxWrapper--f0959";
export var checkmark = "mapLegend-module--checkmark--b97fb";
export var mapKey = "mapLegend-module--mapKey--61f7e";
export var mapKeySvg = "mapLegend-module--mapKeySvg--be51e";
export var mapKeyValue = "mapLegend-module--mapKeyValue--3f6a1";
export var nativeCheckbox = "mapLegend-module--nativeCheckbox--d4175";
export var subheader = "mapLegend-module--subheader--53629";